import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface OpportunityData {
  hasOneTimeInvestment: boolean
  oneTimeInvestmentAmount: number
  hasMonthlyInvestment: boolean
  monthlyInvestmentAmount: number
  investmentProductId: string
  riskAcknowledged: boolean
  durationInMonths: number
}

interface OpportunityState {
  opportunity: OpportunityData
  setOpportunity: (data: Partial<OpportunityData>) => void
  clearOpportunity: () => void
  getOpportunity: () => OpportunityData
}

const useOpportunityStore = create<OpportunityState>()(
  persist(
    (set, get) => ({
      opportunity: {
        hasOneTimeInvestment: false,
        oneTimeInvestmentAmount: 0,
        hasMonthlyInvestment: true,
        monthlyInvestmentAmount: 0,
        investmentProductId: '',
        riskAcknowledged: false,
        durationInMonths: 0,
      },
      setOpportunity: (data: Partial<OpportunityData>) =>
        set((state) => ({
          opportunity: { ...state.opportunity, ...data },
        })),
      clearOpportunity: () =>
        set({
          opportunity: {
            hasOneTimeInvestment: false,
            oneTimeInvestmentAmount: 0,
            hasMonthlyInvestment: true,
            monthlyInvestmentAmount: 0,
            investmentProductId: '',
            riskAcknowledged: false,
            durationInMonths: 0,
          },
        }),
      getOpportunity: () => get().opportunity,
    }),
    {
      name: 'opportunity-store',
    }
  )
)

export default useOpportunityStore
